import React from "react";
import { Modal } from "react-bootstrap";

export function BenefisCategoryDeleteForm({
  deleteBenefisCategory,
  actionsLoading,
  benefisCategory,
  onHide,
}) {
  return (
    <>
      <Modal.Body className="overlay overlay-block cursor-default">
        {actionsLoading && (
          <div className="overlay-layer bg-transparent">
            <div className="spinner spinner-lg spinner-success" />
          </div>
        )}
        <h6 className="text-">
          Apakah anda yakin ingin menghapus{" "}
          <span className="text-danger">{benefisCategory.name}</span>
        </h6>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          onClick={onHide}
          className="btn btn-light btn-elevate"
        >
          Cancel
        </button>
        <> </>
        <button
          type="submit"
          onClick={() => deleteBenefisCategory()}
          className="btn btn-danger btn-elevate"
        >
          Hapus
        </button>
      </Modal.Footer>
    </>
  );
}
